import React from 'react';
import { Helmet } from 'react-helmet-async';

export interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  path: string; // the relative route path, e.g., "/", "/about", etc.
  noindex?: boolean; // if true, render meta robots noindex, nofollow
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title,
  description,
  keywords,
  ogImage,
  path,
  noindex = false,
}) => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const canonicalUrl = `https://triocoresolutions.com.vn${cleanPath}`;

  const fallbackImage = 'https://triocoresolutions.com.vn/logo-triocore.png';

  let imageToUse = fallbackImage;
  if (ogImage) {
    if (ogImage.startsWith('http://') || ogImage.startsWith('https://')) {
      imageToUse = ogImage;
    } else {
      const cleanOgImage = ogImage.startsWith('/') ? ogImage : `/${ogImage}`;
      imageToUse = `https://triocoresolutions.com.vn${cleanOgImage}`;
    }
  }

  return (
    <Helmet>
      {/* Title & Description */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageToUse} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageToUse} />
    </Helmet>
  );
};

export default SEOHead;
